import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "badge"
}
const _hoisted_3 = {
  key: 0,
  class: "panel",
  role: "menu"
}
const _hoisted_4 = { class: "panel-cab" }
const _hoisted_5 = {
  key: 0,
  class: "estado"
}
const _hoisted_6 = {
  key: 1,
  class: "estado vacio"
}
const _hoisted_7 = {
  key: 2,
  class: "lista"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "cuerpo" }
const _hoisted_11 = { class: "titulo" }
const _hoisted_12 = {
  key: 0,
  class: "mensaje"
}
const _hoisted_13 = { class: "tiempo" }
const _hoisted_14 = ["onClick"]

import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import useAutenticar from '@/store/IngresoAutenticar'
import {
  getNotificacionesService,
  getContadorNotificacionesService,
  marcarLeidaService,
  marcarTodasLeidasService,
  type Notificacion
} from '@/services/NotificacionService'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificacionesCampana',
  setup(__props) {

/**
 * Campana de notificaciones con su contador de no leídas.
 *
 * «Leída» se marca con una fecha, no con un booleano, de modo que se conserva
 * cuándo se leyó.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const router = useRouter()
const auth = useAutenticar()

const abierto = ref(false)
const cargando = ref(false)
const contador = ref(0)
const items = ref<Notificacion[]>([])
const raiz = ref<HTMLElement | null>(null)
let intervalo: number | undefined

async function refrescarContador(): Promise<void> {
  if (!auth.autenticado) return
  contador.value = await getContadorNotificacionesService()
}

async function cargarLista(): Promise<void> {
  cargando.value = true
  const r = await getNotificacionesService()
  items.value = r.ok && r.data ? r.data.data : []
  cargando.value = false
}

function toggle(): void {
  abierto.value = !abierto.value
  if (abierto.value) cargarLista()
}

async function abrir(n: Notificacion): Promise<void> {
  if (!n.leida_en) {
    await marcarLeidaService(n.id_notificacion)
    n.leida_en = new Date().toISOString()
    contador.value = Math.max(0, contador.value - 1)
  }
  abierto.value = false
  if (n.enlace) router.push(n.enlace)
}

async function descartar(n: Notificacion): Promise<void> {
  if (!n.leida_en) {
    await marcarLeidaService(n.id_notificacion)
    contador.value = Math.max(0, contador.value - 1)
  }
  items.value = items.value.filter(i => i.id_notificacion !== n.id_notificacion)
}

async function leerTodas(): Promise<void> {
  await marcarTodasLeidasService()
  items.value = items.value.map(n => ({ ...n, leida_en: n.leida_en ?? new Date().toISOString() }))
  contador.value = 0
}

function tiempoRelativo(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime()
  const min = Math.floor(ms / 60000)
  if (min < 1) return 'ahora'
  if (min < 60) return `hace ${min} min`
  const h = Math.floor(min / 60)
  if (h < 24) return `hace ${h} h`
  const d = Math.floor(h / 24)
  return d === 1 ? 'ayer' : `hace ${d} días`
}

function clickFuera(e: MouseEvent): void {
  if (abierto.value && raiz.value && !raiz.value.contains(e.target as Node)) {
    abierto.value = false
  }
}

onMounted(() => {
  refrescarContador()
  intervalo = window.setInterval(refrescarContador, 60000)
  document.addEventListener('click', clickFuera)
})
onBeforeUnmount(() => {
  if (intervalo) window.clearInterval(intervalo)
  document.removeEventListener('click', clickFuera)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "raiz",
    ref: raiz,
    class: "campana-wrap"
  }, [
    _createElementVNode("button", {
      class: "campana",
      "aria-label": `Notificaciones (${contador.value} sin leer)`,
      onClick: toggle
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1.9",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: "icono-campana"
      }, [
        _createElementVNode("path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" }),
        _createElementVNode("path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0" })
      ], -1)),
      (contador.value > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(contador.value > 99 ? '99+' : contador.value), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createVNode(_Transition, { name: "desplegar" }, {
      default: _withCtx(() => [
        (abierto.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[1] || (_cache[1] = _createElementVNode("b", null, "Notificaciones", -1)),
                (contador.value > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "leer-todas",
                      onClick: leerTodas
                    }, "Marcar todas leídas"))
                  : _createCommentVNode("", true)
              ]),
              (cargando.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Cargando…"))
                : (!items.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[2] || (_cache[2] = [
                      _createElementVNode("span", { class: "vacio-ico" }, "✓", -1),
                      _createElementVNode("p", null, "Estás al día", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (n) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: n.id_notificacion,
                          class: _normalizeClass(["item", { 'no-leida': !n.leida_en }]),
                          onClick: ($event: any) => (abrir(n))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["sev", 'sev-' + n.severidad]),
                            title: n.severidad
                          }, _toDisplayString(n.severidad === 'critica' ? '⚠' : n.tipo === 'recordatorio' ? '📅' : '•'), 11, _hoisted_9),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(n.titulo), 1),
                            (n.mensaje)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(n.mensaje), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(tiempoRelativo(n.created_at)), 1)
                          ]),
                          _createElementVNode("button", {
                            class: "btn-descartar",
                            title: "Descartar",
                            onClick: _withModifiers(($event: any) => (descartar(n)), ["stop"])
                          }, "✕", 8, _hoisted_14)
                        ], 10, _hoisted_8))
                      }), 128))
                    ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})